export enum MortgageIncreaseReasonToIncrease {
  SustainableRenovation = 'SustainableRenovation',
  BigExpense = 'BigExpense'
}

export enum MortgageIncreaseBigExpenseType {
  DonationOrVacationHouse = 'DonationOrVacationHouse',
  Vehicle = 'Vehicle',
  Other = 'Other'
}
